import React from 'react';
import { translate } from 'translations/i18n';

const EmptyState = () => {
  return (
    <p className="instructions">
      {translate('showcases.setupGuide.nullShowcase.instructions')}
    </p>
  );
};

export default EmptyState;
